module.exports = __webpack_public_path__ + "static/img/James_Sicily_desktop.8d7a877.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/James_Sicily_desktop.jpg
// module id = tUrE
// module chunks = 0